<template>
<v-card tile :flat='flat' v-bind='attrs' class='pb-5' >
  <img style='position:absolute;left:10px;top:110px;z-index:1;max-width:150px;'
    :height='80' aspect-ratio :src='logoImage' />
  <v-img :src='backgroundImage' :height='160' >
  </v-img>
  <v-btn absolute top right small
    :to='`/settings/spaces/${space.id}`' >
    Edit
  </v-btn>
  <v-btn v-if='cta' absolute top right small
    class='mr-15'
    :to='cta.link'
    :color='cta.color' >
    {{cta.text}}
    <v-icon v-if='cta.icon' class='ml-1' >{{cta.icon}}</v-icon>
  </v-btn>
  <v-divider></v-divider>
  <v-card-title
    class='py-0 grey lighten-3 overline'
    v-if='space.title' >
    <v-spacer/>
    {{ space.title }}
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text v-if='space && settings'>
    <center >
      <h2>{{ settings.practice_name }}</h2>
      <small v-if='settings.practice_number' >
        <strong>Practice number:</strong>
        {{settings.practice_number}}
      </small>
      <br/>
    </center>

    <v-card flat v-if='members && members.length > 0'  >
      <v-list dense class='elevation-5 pa-0 mt-3' >
        <v-toolbar dense flat class='grey lighten-4' >
          <v-icon class='mr-2' >mdi-account-group</v-icon>
          <v-btn text :to='`/settings/spaces/${this.spaceId}/team`' >Team</v-btn>
          <v-btn fab bottom right absolute small dark
            @click='launchInviteWizard(spaceId)'
            color='pink' ><v-icon>mdi-plus</v-icon></v-btn>
        </v-toolbar>
        <v-divider />
        <!-- <v-subheader class='overline grey lighten-4' >
          <v-icon class='mr-2' >mdi-account-group</v-icon>
          Team</v-subheader> -->
        <v-subheader >Active members</v-subheader>
        <template v-for='member in members' >
          <practitioner-list-item
            v-if='member.is_active'
            @selected='$router.push({path: `/settings/spaces/${spaceId}/members/${member.id}`})'
            :item='member' :key='member.id' with-chevron >

            <v-chip slot="chips" :key='`chip-${member.id}`' x-small outlined label >
              {{member.role}}
            </v-chip>

            <v-list-item-action slot='actions' >
              <v-menu :close-on-content-click='false' open-on-hover >
                <template v-slot:activator="{ on }">
                <v-btn v-on='on' slot='activator' small icon color='primary' >
                  <v-icon>mdi-star-outline</v-icon>
                </v-btn>
                </template>
                <v-card>
                  <v-card-title class='caption py-0 grey lighten-4' >
                    {{member.practitioner_name}}'s
                    appointment types
                  </v-card-title>
                  <v-divider/>
                  <v-list dense>
                    <v-list-item v-for='product in getMemberProducts(member.practitioner)' :key='product.id' >
                      <v-list-item-content>
                        <v-list-item-title v-text='product.title' />
                        <v-list-item-subtitle v-if='product.locations' >
                          <v-chip x-small label outlined v-for='loc in product.locations' :key='loc.id' class='mr-1' >
                            <v-icon x-small left >mdi-map-marker</v-icon>
                            {{loc.name}}
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if='getMemberProducts(member.practitioner).length === 0' >
                      <v-list-item-content>
                        <v-list-item-title >No appointment types defined</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-list-item-action>
          </practitioner-list-item>
          <v-divider :key='`d-${member.id}`' />
        </template>
        <v-footer
          v-if='invitations && invitations.length > 0'
          class='py-1 caption' >
          <v-spacer/>
          {{invitations.length}}
          invitation<span v-if='invitations.length > 1' class='mr-1' >s</span> pending
        </v-footer>
      </v-list>
    </v-card>

    <template v-if='space && space.addresses && space.addresses.length > 0' >
      <v-btn text
        :to='`/settings/spaces/${spaceId}/locations/`' class="my-3 overline pa-0" >
        <v-icon class='mr-2' >mdi-map-marker-multiple-outline</v-icon>
        Locations
      </v-btn >
      <v-row >
        <location-chip class='ml-2 mb-2'
          v-for='loc in space.addresses'
          :key='loc'
          :space-id='spaceId' :location-id='getLocationId(loc)'
          @selected='bubbleLocationSelected' />
        <v-chip @click='launchNewLocationWizard(spaceId)' class='ml-2' ><v-icon left small >mdi-plus</v-icon>
         Add a location
        </v-chip>
      </v-row>
    </template>

    <template v-if='space.settings' >
      <v-subheader class="mt-3 overline pa-0" >Invoice details</v-subheader>
      <v-row>
        <v-col>
          <strong>Practice name:</strong><br/>{{space.settings.practice_name}}<br/>
        </v-col>
        <v-col>
          <strong>Practice number:</strong><br/>{{space.settings.practice_number}}<br/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <strong>Banking details:</strong><br/>
          <pre
            class='caption'
            v-text='space.settings.banking_details' />
        </v-col>
        <v-col>
          <strong>Billing address:</strong><br/>
          <pre
            class='caption'
            v-text='space.settings.billing_address' />
        </v-col>
      </v-row>

      <asset-view
        object-type="space"
        :object="space" class="mt-3" />

      <v-subheader class="mt-3 overline pa-0" >Social media</v-subheader>
      <template v-for='social in socials' >
        <v-chip
          v-if='social in space.settings && space.settings[social]'
          :key='social'
          small outlined
          color='primary' class='mr-2 mt-1' >
          <v-icon small left>mdi-{{social}}</v-icon>
          {{ space.settings[social] }}
        </v-chip>
      </template>
    </template>
  </v-card-text>
  <slot name='actions' >
  </slot>
  <v-footer absolute bottom >
    <v-chip x-small label outlined >#{{space.id}}. {{space.title}}</v-chip>
  </v-footer>
</v-card>
</template>
<script>
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import LocationChip from '@/components/listitems/LocationChip.vue'
import AssetView from '@/views/team/AssetView.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'SpaceCard',
  components: {PractitionerListItem, LocationChip, AssetView},
  props: {
    value: { type: Object, default: () => { return {} } },
    cta: { type: Object, required: false },
    flat: { type: Boolean, default: true },
    attrs: { type: Object, default: () => {} },
    withInvite: { type: Boolean, default: false }
  },
  data () {
    return {
      socials: ['instagram', 'facebook', 'twitter']
    }
  },
  // watch: {
  //   value: {
  //     immediate: true,
  //     handler () {
  //       if (this.value) { this.space = this.value }
  //     }
  //   }
  // },
  computed: {
    ...mapGetters('identity', ['getProducts']),
    space () {
      return this.value
    },
    spaceId () {
      return this.getObjectPath(this.value, 'id', null)
    },
    backgroundImage () {
      return this.getObjectPath(this.space, 'settings.background_picture')
    },
    logoImage () {
      return this.getObjectPath(this.space, 'settings.logo_picture')
    },
    settings () {
      if (this.space && this.space.settings) {
        return this.space.settings
      }
      return {}
    },
    members () {
      if (this.space && this.space.service_practitioners) {
        return this.space && this.space.service_practitioners
      }
      return []
    },
    invitations () {
      return this.members.filter((member) => {
        if (member.is_active === false && member.is_archived === false) {
          return member
        }
      })
    }
  },
  methods: {
    bubbleLocationSelected (val) {
      this.$emit('location:selected', val)
    },
    getMemberProducts (practitionerId) {
      let options = {
        spaceId: this.spaceId,
        practitionerId: practitionerId
      }
      return this.getProducts(options)
    },
    getLocationId (loc) {
      if (isNaN(loc) && loc.id) {
        return loc.id
      }
      return loc
    }
  }
}
</script>
<style scoped>
.small { font-size:smaller;}
</style>
